import useCookie from '~/hooks/useCookie'

import { useEffect, useState } from 'react'
import type { TypeWebsiteNotification } from '~/types/contentful'
import { CloseIcon } from '../icons'
import type { LinksFunction } from '@remix-run/node'

import styles from './styles.css?url'

export const links: LinksFunction = () => [{ rel: 'stylesheet', href: styles }]

export const NOTIFICATION_COOKIE = 'notification_closed' as const
type NotificationProps = {
  notificationInfo: TypeWebsiteNotification<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const Notification = ({ notificationInfo }: NotificationProps): JSX.Element => {
  const { getCookie, setCookie } = useCookie()
  const [notificationCookie, setNotificationCookie] = useState<boolean | undefined>(false)
  const { fields } = notificationInfo || { fields: undefined }

  const closeNotification = () => {
    setCookie(NOTIFICATION_COOKIE, 'true', window.location.hostname, 365)
    setNotificationCookie(true)
  }

  const renderNotification = (): boolean => {
    if (notificationCookie || !fields) return false

    const { endDate, startDate } = fields
    if (!endDate || !startDate) return false

    const currentDate = new Date()
    if (currentDate < new Date(startDate.toString()) || currentDate > new Date(endDate.toString()))
      return false

    return true
  }

  useEffect(() => {
    const cookie = getCookie(NOTIFICATION_COOKIE)
    if (cookie) setNotificationCookie(cookie)
  }, [])

  if (!renderNotification()) return <></>

  return (
    <div
      id="notification-container"
      className="flex p-3 rounded-[30px] flex-col lg:flex-row lg:justify-center bg-blue-10"
      style={{ backgroundColor: `#${fields?.backgroundColour}` }}
    >
      <div className="flex flex-col lg:flex-row lg:gap-1 justify-center">
        <p className="self-center">
          {fields?.title} {fields?.description}
        </p>
        <a className="text-blue-50 self-center ml-1" href={fields?.link}>
          {fields?.ctaText}
        </a>
      </div>
      <div
        className="cursor-pointer bg-white opacity-60 flex rounded-[32px] h-fit self-center absolute right-6 lg:right-12"
        onClick={closeNotification}
      >
        <CloseIcon className="opacity-100 w-7 h-7" />
      </div>
    </div>
  )
}
